import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from '../models/auth.models';

export enum UserPipeType {
  initials = 'initials',
  all = 'all'
}

@Pipe({
  name: 'xUser',
  pure: false
})
export class XUserPipe implements PipeTransform {

  locale;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private translateService: TranslateService
  ) {
    this.locale = this.translateService.currentLang;
    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.locale = value.lang;
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  transform(value: any, type?: any): string {
    if (type === UserPipeType.initials) {
      return new User(value).getInitials(this.locale);
    } else {
      return new User(value).getName(this.locale);
    }
  }

}
